var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C17.5193 2 22 6.48067 22 12C22 17.5193 17.5193 22 12 22C6.48067 22 2 17.5193 2 12C2 6.48067 6.48067 2 12 2ZM11.3333 3.35867C7.08133 3.68267 3.68267 7.08133 3.35867 11.3333H4C4.368 11.3333 4.66667 11.632 4.66667 12C4.66667 12.368 4.368 12.6667 4 12.6667H3.35867C3.68267 16.9187 7.08133 20.3173 11.3333 20.6413V20C11.3333 19.632 11.632 19.3333 12 19.3333C12.368 19.3333 12.6667 19.632 12.6667 20V20.6413C16.9187 20.3173 20.3173 16.9187 20.6413 12.6667H19.864C19.496 12.6667 19.1973 12.368 19.1973 12C19.1973 11.632 19.496 11.3333 19.864 11.3333H20.6413C20.3173 7.08133 16.9187 3.68267 12.6667 3.35867V4C12.6667 4.368 12.368 4.66667 12 4.66667C11.632 4.66667 11.3333 4.368 11.3333 4V3.35867ZM12.6667 11.724L15.8047 14.862C16.0647 15.122 16.0647 15.5447 15.8047 15.8047C15.5447 16.0647 15.122 16.0647 14.862 15.8047L11.5287 12.4713C11.4033 12.3467 11.3333 12.1767 11.3333 12V7.33333C11.3333 6.96533 11.632 6.66667 12 6.66667C12.368 6.66667 12.6667 6.96533 12.6667 7.33333V11.724Z",
    fill: "#CC0018"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.3bfaec33d97d11546780ea57e70cf9d4.svg";
export { ForwardRef as ReactComponent };